var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"scroll-to-top-btn",class:{ visible: _vm.showSrocllToTop },on:{"click":function($event){$event.preventDefault();return _vm.srocllToTop()}}},[_c('i',{staticClass:"fa fa-arrow-up",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }